import React from "react";
import AnimatedNumbers from "react-animated-numbers";
// import { ToastContainer } from "react-toastify";
import FooterFooter from "../../components/footerfooter";
//IMPORT DYNAMIC STYLED COMPONENT
import { StyledHeader } from "../../Styles";
import "./styles/newMint.scss";
import { CONFIG } from "../../../config.js";
import { ABI, DashboardFunctions } from "./functions";
import { toast, ToastContainer } from "react-toastify";

import { useMoralis, useWeb3ExecuteFunction } from "react-moralis";

//SWITCH VARIABLE FOR PAGE STYLE
const theme = "GREY"; //LIGHT, GREY, RETRO

const NewMiniMint = () => {
  const {
    authenticate,
    isAuthenticated,
    user,
    Moralis,
    setUserData,
    userError,
    isWeb3Enabled,
    account,
    ...xyz
  } = useMoralis();

  const notifySuccess = (message) =>
    toast.success(message, {
      position: "bottom-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "dark",
    });
  const notifyInfo = (message) =>
    toast.info(message, {
      position: "bottom-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "dark",
    });
  const notifyError = (message) =>
    toast.error(message, {
      position: "bottom-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "dark",
    });

  const { data, error, fetch, isFetching, isLoading } =
    useWeb3ExecuteFunction();
  async function mintNFT2(val) {
    await Moralis.enableWeb3();

    const etherValue = val * 0.075;
    let options = {
      chain: CONFIG.chainID,
      contractAddress: CONFIG.smart_contract_minimoose,
      functionName: "mintMiniMoose",
      abi: ABI.mintMiniMoose,
      params: {
        _count: val,
      },
      msgValue: Moralis.Units.ETH(etherValue),
    };
    // await Moralis.enableWeb3();
    console.log("mintUser=>", user);
    try {
      const mintTransaction = await Moralis.executeFunction(options);
      console.log(
        "mintTransaction=>",
        mintTransaction,
        "mintTransactionhash",
        mintTransaction.hash
      );
      notifyInfo("Please wait for confirmation");
      await mintTransaction.wait();
      notifySuccess("Please reload after sometime to get the minted NFT");
    } catch (e) {
      console.log("mintError=>", e);
      notifyError("Oops some problem occured! Please try again later!");
    }
    if (
      typeof error?.code == "undefined" &&
      typeof error?.data != "undefined"
    ) {
      notifySuccess("Please Wait For Sometime Transaction is Successful");
    } else if (typeof error?.code != "undefined") {
      notifyError("There is some error Please Try Again Later");
    }
  }
  return (
    <>
      <div className="greyscheme">
        <StyledHeader theme={theme} />
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          theme="dark"
          pauseOnHover
        />
        <div className="greyscheme">
          <section className="container">
            <div className="hero_section_mint">
              <div className="row">
                <div className="col-md-6 content_col">
                  <div className="hero_content">
                    <div
                      className="title"
                      data-aos="fade-up"
                      data-aos-delay="500"
                      data-aos-duration="5000"
                      data-aos-once="true"
                      data-aos-easing="ease-in-out"
                    >
                      <h2>It's Time To Start Your Journey!</h2>
                      <span className="divider"></span>
                    </div>
                    <div className="button_text">
                      <button className="mint" onClick={() => mintNFT2(1)}>
                        Mini
                      </button>
                      <button className="dropdown">have dropdown here</button>
                    </div>
                    <div className="counter_number">
                      <div
                        className="counter_wrapper"
                        data-aos="fade-up"
                        data-aos-delay="800"
                        data-aos-duration="5000"
                        data-aos-once="true"
                        data-aos-easing="ease-in-out"
                      >
                        <span className="count">
                          <AnimatedNumbers
                            includeComma
                            animateToNumber={1042}
                            fontStyle={{ fontSize: 30 }}
                            configs={[
                              { mass: 1, tension: 220, friction: 100 },
                              { mass: 1, tension: 180, friction: 130 },
                              { mass: 1, tension: 280, friction: 90 },
                              { mass: 1, tension: 180, friction: 135 },
                              { mass: 1, tension: 260, friction: 100 },
                              { mass: 1, tension: 310, friction: 280 },
                            ]}
                          ></AnimatedNumbers>
                        </span>
                        <div className="text">Holders</div>
                      </div>
                      <div
                        className="counter_wrapper"
                        data-aos="fade-up"
                        data-aos-delay="800"
                        data-aos-duration="5000"
                        data-aos-once="true"
                        data-aos-easing="ease-in-out"
                      >
                        <span className="count">
                          <AnimatedNumbers
                            includeComma
                            animateToNumber={3869}
                            fontStyle={{ fontSize: 30 }}
                            configs={[
                              { mass: 1, tension: 220, friction: 100 },
                              { mass: 1, tension: 180, friction: 130 },
                              { mass: 1, tension: 280, friction: 90 },
                              { mass: 1, tension: 180, friction: 135 },
                              { mass: 1, tension: 260, friction: 100 },
                              { mass: 1, tension: 210, friction: 180 },
                            ]}
                          ></AnimatedNumbers>
                        </span>
                        <div className="text">Minted</div>
                      </div>
                      <div
                        className="counter_wrapper"
                        data-aos="fade-up"
                        data-aos-delay="800"
                        data-aos-duration="5000"
                        data-aos-once="true"
                        data-aos-easing="ease-in-out"
                      >
                        <span className="count">
                          <AnimatedNumbers
                            includeComma
                            animateToNumber={5000}
                            fontStyle={{ fontSize: 30 }}
                            configs={[
                              { mass: 1, tension: 220, friction: 100 },
                              { mass: 1, tension: 180, friction: 130 },
                              { mass: 1, tension: 280, friction: 90 },
                              { mass: 1, tension: 180, friction: 135 },
                              { mass: 1, tension: 260, friction: 100 },
                              { mass: 1, tension: 210, friction: 180 },
                            ]}
                          ></AnimatedNumbers>
                        </span>
                        <div className="text">Moose</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div
                    className="hero_image"
                    data-aos="fade-up"
                    data-aos-delay="500"
                    data-aos-duration="5000"
                    data-aos-once="true"
                    data-aos-easing="ease-in-out"
                  >
                    <div className="image_bg">
                      <div className="img_wrapper">
                        <img
                          src="https://moosesocietynft.io/wp-content/uploads/elementor/thumbs/website-graphics2-pm0u2ukuay0ypbwhoxxh6w6p0ww87janzqbqpa26rs.png"
                          alt="img"
                          data-aos="fade-up"
                          data-aos-delay="1000"
                          data-aos-duration="5000"
                          data-aos-once="true"
                          data-aos-easing="ease-in-out"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <br />
          <br />
          <FooterFooter />
        </div>
      </div>
    </>
  );
};

export default NewMiniMint;
